export class AnnouncementModel {
  id: string;
  title: string;
  body: string;
  supports: any[];
  alias?: string;
  createdAt: Date;

  constructor(item: any) {
    this.id = item.id;
    this.title = item.title;
    this.body = item.body;
    this.alias = item.alias;
    this.supports = item.supports || [];
    this.createdAt = item.createdAt;
  }

  static fromJson(item: any): AnnouncementModel {
    return new AnnouncementModel(item);
  }
}
